import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { IWidget } from "../../../../models/application/i-widget";
import { widgetRestClientInjectionToken } from "../../../../rest-clients/application/widget/widget-rest-client-injection-token";
import { IWidgetRestClient } from "../../../../rest-clients/application/widget/i-widget-rest.client";
import { IPage } from "@zaeper/communication-lib";

@Injectable()
export class WidgetPageResolver implements Resolve<IPage<IWidget>> {
  constructor(@Inject( widgetRestClientInjectionToken ) private readonly _widgetRestClient: IWidgetRestClient) {
  }

  resolve(route: ActivatedRouteSnapshot): Promise<IPage<IWidget>> {
    return this._widgetRestClient.getApplicationPage( {
      pageNumber: 0,
      pageSize: 100
    } )
  }
}
